import fetch from './fetch';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default { fetch };
